<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Submit Change Request
							</div>
				
							<div class="page_main">
								<div class="change-request-page">
				
									<div class="btn_el">
										<div class="tips">
											Please provide a summary of the change request along with sufficient justification or rationale.
										</div>
									</div>
				
									<div class="btn_el">
										<div class="tips">
											After clicking <strong>"Submit and Save"</strong>, the system will automatically create a change request record, which can be viewed in the <strong>"Search Change Requests"</strong> menu.
										</div>
									</div>
				
									<div class="btn_el">
										<div class="tips">
											After submitting the change request, please complete the document information and finish the review task as soon as possible in <strong>"My Tasks"</strong>.
										</div>
									</div>
				
									<el-form
										ref="formRef"
										:model="form"
										:rules="rules"
										label-position="top"
									>
										<el-form-item
											label="Change Request Summary"
											prop="overall_description"
										>
											<el-input
												v-model="form.overall_description"
												type="textarea"
												:rows="7"
												resize="none"
												placeholder=""
											/>
										</el-form-item>
				
										<el-form-item
											label="Justification / Rationale"
											prop="reason"
										>
											<el-input
												v-model="form.reason"
												type="textarea"
												:rows="7"
												resize="none"
												placeholder=""
											/>
										</el-form-item>
									</el-form>
				
									<!--
									<div class="divider"></div>
				
									<div class="btn_el">
										<div class="tips">
											Identify all documents included in this change request, including new documents for release, existing documents to be revised or obsoleted, and obsolete documents to be restored.
										</div>
									</div>
									-->
				
									<div v-if="false" class="file-panel">
										<div class="panel-header">
											<div class="panel-title">
												Documents Included in the Change Request
											</div>
										</div>
				
										<el-table
											:data="filteredTableData"
											border
											class="file-table"
											header-cell-class-name="table-header-cell"
											empty-text="No documents have been added to this change request."
										>
											<el-table-column
												prop="ref"
												label="Document Number"
												min-width="120"
											/>
				
											<el-table-column
												prop="currentVersion"
												label="Current Revision"
												min-width="110"
											>
												<template #default="scope">
													{{ '/' }}
												</template>
											</el-table-column>
				
											<el-table-column
												prop="vnumber"
												label="New Revision"
												min-width="120"
											/>
				
											<el-table-column
												prop="vname"
												label="Document Name"
												min-width="140"
											/>
				
											<el-table-column
												prop="docType"
												label="Document Type"
												min-width="120"
											>
												<template #default="scope">
													{{ initResources(scope.row.leixing_id) }}
												</template>
											</el-table-column>
				
											<el-table-column
												prop="vdesc"
												label="Change Description"
												min-width="160"
											/>
										</el-table>
				
										<div class="table-btns">
											<el-button
												:disabled="resourcesAddStatus"
												type="primary"
												@click="handleCreate"
											>
												Create New Document
											</el-button>
				
											<el-button
												:disabled="resourcesAddStatus"
												type="primary"
												@click="handleCurrentEdit"
											>
												Use Existing Document
											</el-button>
				
											<el-button
												:disabled="resourcesAddStatus"
												type="primary"
												@click="handleCurrentInvalid"
											>
												Obsolete Existing Document
											</el-button>
				
											<el-button
												:disabled="resourcesAddStatus"
												type="primary"
												@click="handleRestoreInvalid"
											>
												Restore Obsolete Document
											</el-button>
										</div>
									</div>
				
									<div class="footer-actions">
										<el-button
											type="primary"
											class="custom-btnlight"
											@click="handleSaveContinue"
										>
											Submit and Save
										</el-button>
				
										<!--
										<el-button
											type="primary"
											class="custom-btnlight"
											disabled
											@click="handleSaveContinue"
										>
											Sign
										</el-button>
										-->
				
										<el-button
											type="primary"
											@click="handleCancel"
										>
											Cancel
										</el-button>
									</div>
				
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading--></div>
</template>

<script>
import { resourcesLeixingList } from '@/api/docManage/configureDocControl/index';
import { resourcesGetflow, resourcesSubmit } from '@/api/docManage/changeRequest/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export default {
	components:{
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			keyword: "",
			form: {
				overall_description: "",
				reason: "",
			},
			rules: {
				overall_description: [{
					required: true,
					message: "Please enter a general description of the change request",
					trigger: "blur",
				},
				],
				reason: [{
					required: true,
					message: "Please enter the reason/basis for the change request",
					trigger: "blur",
				},
				],
			},
			// filteredTableData: [],
			// resourcesAddStatus: localStorage.getItem('resourcesAdd') ? true : false,
			// resourcesLeixingList: [],
			// json: null
		};
	},
	computed: {
		//
	},
	created() {
		let that = this;
		// if(that.resourcesAddStatus) {
		// 	that.filteredTableData.push(JSON.parse( localStorage.getItem('resourcesAdd')));
		// 	//请求文件类型
		// 	resourcesLeixingList({ page: 1, page_size: 9999, keyword: '' }).then(res => {
		// 		if(res.code == 200) {
		// 			//获取审批流
		// 			resourcesGetflow({ 'leixing_id': that.filteredTableData[0].leixing_id }).then(res2 => {
		// 				if(res2.code == 200) {
		// 					that.resourcesLeixingList = res.data.data;
		// 					that.json = JSON.stringify(res2.data);
		// 				}
		// 			});
		// 		}
		// 	});
		// }
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//处理文档类型数据
		initResources(val) {
			let str = '';
			this.resourcesLeixingList.forEach((value, index) => {
				if(value.id == val) { str = value.title; }
			});
			return str;
		},
		//创建新文档
		handleCreate() {
			let that = this;
			that.$refs.formRef.validate((valid, object) => {
				if(valid) {
					// that.goUrl("/DocControl/changeRequestAddNewFile");
				}
			});
		},
		//使用现有文档
		handleCurrentEdit() {
			let that = this;
			that.goUrl("/DocControl/changeRequestAddExistFlie");
		},
		//废弃现有文档
		handleCurrentInvalid() {
			let that = this;
			that.goUrl("/DocControl/changeRequestAbandonFile");
		},
		//恢复过时文档
		handleRestoreInvalid() {
			let that = this;
			that.goUrl("/DocControl/changeRequestrecoveryFile");
		},
		//提交并保存
		handleSaveContinue() {
			let that = this;
			that.$refs.formRef.validate((valid, object) => {
				if (valid) {
					that.$confirm("Confirm submission request?", "Confirmation", {
						type: "warning",
					}).then(() => {
						// 校验通过，提交表单
						that.$toast.loading({ duration: 0, forbidClick: true });
						resourcesSubmit({
							flow_type: 'resources_update',
							overall_description: that.form.overall_description,
							reason: that.form.reason,
							id: ''
						}).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								setTimeout(() => {
									that.$router.push({ path: '/task-list' });
								}, 800);
							}
						});
					}).catch(() => {});
				}
			});
		},
		handleCancel() {
			this.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		}
	},
};
</script>

<style lang="less" scoped>
//主要内容 
.main_main {
    .page_main {
         padding: 18px 20px;
         .btn_el{
         	margin: 10px 0 20px 0;
         	border-radius: 6px;
         	background-color: #ffb1001a;
         	padding: 10px 8px;
         	.tips{
         		padding: 2px 0;
         		font-size: 16px;
         		font-weight: bold;
         	}
         }
    }
     //页头
	.page_header {
         padding: 0 20px;
         height: 60px;
         line-height: 60px;
         background-color: #d8e4f0;
         font-size: 24px;
         font-weight: bold;
         box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
    }
}
 </style> <style scoped> .main_box {
     height: calc(100vh - 60px);
     overflow-y: auto;
}
 .main_box .main_main {
     position: relative;
     min-height: calc(100% - 0px);
     max-height: auto;
     background-color: #fafafa;
}
 .el-header, .el-main {
     padding: 0;
}
 .change-request-page {
     padding: 12px 14px 24px;
     min-height: 100vh;
     box-sizing: border-box;
}
 .divider {
     height: 1px;
     background: #dcdfe6;
     margin: 8px 0 18px;
}
 .tip-box {
     background: #f5efe3;
     border-radius: 4px;
     color: #333;
     padding: 14px 12px;
     margin-bottom: 18px;
     font-size: 14px;
     line-height: 22px;
     font-weight: 600;
}
 .file-panel {
     background: #fff;
     border: 1px solid #dcdfe6;
}
 .panel-header {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 8px 10px 0;
}
 .panel-title {
     font-size: 18px;
     font-weight: 700;
     color: #222;
     line-height: 32px;
}
 .panel-actions {
     display: flex;
     align-items: center;
     gap: 10px;
}
 .search-input {
     width: 220px;
}
 .icon-btn {
     width: 32px;
     height: 32px;
     padding: 0;
}
 .file-table {
     width: 100%;
     margin-top: 8px;
}
 .table-btns {
     padding: 18px 0 10px 4px;
}
 .footer-actions {
     margin-top: 26px;
     display: flex;
     justify-content: center;
     gap: 14px;
}
 </style>
